// extracted by mini-css-extract-plugin
export var container = "styles-module--container--w2Lkc";
export var heading = "styles-module--heading--WbNX0";
export var list = "styles-module--list--fx7Qs";